import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import Step from './Step.react';
import VideoPlayer from '../modal/VideoPlayer.modal';
var HydroTip = function HydroTip(_ref) {
  var showModalAction = _ref.showModalAction;
  var openVideo = function openVideo() {
    showModalAction({
      component: /*#__PURE__*/React.createElement(VideoPlayer, {
        url: "/public/videos/2-final-hydrotip-info-video.mp4"
      })
    });
  };
  var submitApplication = function submitApplication() {
    window.open('/public/files/hydrotip-demo.pdf', '_blank');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__text"
  }, /*#__PURE__*/React.createElement("h1", null, "Introducing Posillico Materials Hydro:Tip"), /*#__PURE__*/React.createElement("p", null, "Dispose Hydro-Excavation waste simply at Posillico Materials"), /*#__PURE__*/React.createElement("a", {
    href: "/public/files/hydrotip-demo.pdf",
    target: "_blank"
  }, "Submit a Disposal Application"), /*#__PURE__*/React.createElement("p", null, "See it in action"), /*#__PURE__*/React.createElement("p", null, "Hydro:Tip is the safest, cleanest, and fastest vacuum truck unloading system on Long Island"), /*#__PURE__*/React.createElement("p", null, "This tipping station is dedicated to liquid waste, minimizing operations time at the disposal facility while maximising their time serving customers. Ultimately lowering disposal and transportation costs, while keeping waste material out of the landfill."), /*#__PURE__*/React.createElement("p", null, "The waste stream we accept include Drilling Muds, Dry Wells, Storm Drains, Dredge Spoils, Street Sweepings, Car Wash Grit, Catch Basin Material and Water Systems."), /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    href: "/public/files/hydrotip-demo.pdf",
    target: "_blank"
  }, "Submit an Application")), /*#__PURE__*/React.createElement("p", null, "Quick and easy approval provess. Guaranteed response in 24 hours!"), /*#__PURE__*/React.createElement("h2", null, "Dump"), /*#__PURE__*/React.createElement("p", null, "Upon arrival, waste is unloaded safely by direct feed into the Hydro:Tip, quickly and efficiently"), /*#__PURE__*/React.createElement("h2", null, "Rinse & Recycle"), /*#__PURE__*/React.createElement("p", null, "Our process separates the liquids and solids, allowing for recycling of high-quality aggregates. The water is cleaned and reused in the process. Your tanker will be clean before the material is finished processing!"), /*#__PURE__*/React.createElement("p", null, "Back to the road in as little as 20 minutes, ready to serve your next customer!"), /*#__PURE__*/React.createElement("p", null, "Questions? Contact us for ", /*#__PURE__*/React.createElement("a", {
    href: "tel:6313905777"
  }, "631.390.5777"), " for more information")), /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__intro--body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__intro--backdrop"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/hydrotip-header-mobile.png",
    className: "ht-mobile__intro--header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/Submit-disposal-application.png",
    className: "ht-mobile__intro--submit",
    onClick: function onClick() {
      return submitApplication();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/see-hydrotip.png",
    className: "ht-mobile__intro--see",
    onClick: function onClick() {
      return openVideo();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/this-state-of-the-art-facility-has-revolutionized-the-way-we-th@3x.png",
    className: "ht-mobile__intro--p"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step1--body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step1--backdrop"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-1@3x.png",
    className: "ht-mobile__step1--nr"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-1-header-mobile@3x.png",
    className: "ht-mobile__step1--header",
    onClick: function onClick() {
      return submitApplication();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-1-subhead-mobile@3x.png",
    className: "ht-mobile__step1--p"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step2--body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step2--backdrop"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-2@3x.png",
    className: "ht-mobile__step2--nr"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-2-dump@3x.png",
    className: "ht-mobile__step2--header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-2-subhead-mobile@3x.png",
    className: "ht-mobile__step2--p"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step3--body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__step3--backdrop"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-3@3x.png",
    className: "ht-mobile__step3--nr"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-3-header-mobile@3x.png",
    className: "ht-mobile__step3--header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/step-3-subhead-mobile@3x.png",
    className: "ht-mobile__step3--p"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__footer--body"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/final-break-mobile@3x.png",
    className: "ht-mobile__footer--bar"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/mobile/final-mobile@3x.png",
    className: "ht-mobile__footer--p"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "hydro-tip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-mobile__text"
  }, /*#__PURE__*/React.createElement("h1", null, "Introducing Posillico Materials Hydro:Tip"), /*#__PURE__*/React.createElement("p", null, "Dispose Hydro-Excavation waste simply at Posillico Materials"), /*#__PURE__*/React.createElement("a", {
    href: "/public/files/hydrotip-demo.pdf",
    target: "_blank"
  }, "Submit a Disposal Application"), /*#__PURE__*/React.createElement("p", null, "See it in action"), /*#__PURE__*/React.createElement("p", null, "Hydro:Tip is the safest, cleanest, and fastest vacuum truck unloading system on Long Island"), /*#__PURE__*/React.createElement("p", null, "This tipping station is dedicated to liquid waste, minimizing operations time at the disposal facility while maximising their time serving customers. Ultimately lowering disposal and transportation costs, while keeping waste material out of the landfill."), /*#__PURE__*/React.createElement("p", null, "The waste stream we accept include Drilling Muds, Dry Wells, Storm Drains, Dredge Spoils, Street Sweepings, Car Wash Grit, Catch Basin Material and Water Systems."), /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    href: "/public/files/hydrotip-demo.pdf",
    target: "_blank"
  }, "Submit an Application")), /*#__PURE__*/React.createElement("p", null, "Quick and easy approval provess. Guaranteed response in 24 hours!"), /*#__PURE__*/React.createElement("h2", null, "Dump"), /*#__PURE__*/React.createElement("p", null, "Upon arrival, waste is unloaded safely by direct feed into the Hydro:Tip, quickly and efficiently"), /*#__PURE__*/React.createElement("h2", null, "Rinse & Recycle"), /*#__PURE__*/React.createElement("p", null, "Our process separates the liquids and solids, allowing for recycling of high-quality aggregates. The water is cleaned and reused in the process. Your tanker will be clean before the material is finished processing!"), /*#__PURE__*/React.createElement("p", null, "Back to the road in as little as 20 minutes, ready to serve your next customer!"), /*#__PURE__*/React.createElement("p", null, "Questions? Contact us for ", /*#__PURE__*/React.createElement("a", {
    href: "tel:6313905777"
  }, "631.390.5777"), " for more information")), /*#__PURE__*/React.createElement("div", {
    className: "ht-intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-intro__body"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/bracket@3x.png",
    className: "ht-intro__body--bracket"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/this-state-of-the-art-facility-has-revolutionized-the-way-we-th@3x.png",
    className: "ht-intro__body--txt-3"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/Header.png",
    className: "ht-intro__body--header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/Subhead.png",
    className: "ht-intro__body--sub-header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/subhead-static.png",
    className: "ht-intro__body--dispose"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/subhead-submit-application.png",
    className: "ht-intro__body--application"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/subhead-submit-application-RO.png",
    className: "ht-intro__body--application-ro",
    onClick: function onClick() {
      return submitApplication();
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/subhead-see-it-in-action.png",
    className: "ht-intro__body--action"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/intro/subhead-see-it-in-action-RO.png",
    className: "ht-intro__body--action-ro",
    onClick: function onClick() {
      return openVideo();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "ht-intro__body--backdrop"
  }))), /*#__PURE__*/React.createElement(Step, null), /*#__PURE__*/React.createElement("div", {
    className: "ht-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ht-footer__body"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/footer/divider@3x.png",
    className: "ht-footer__body--divider"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/footer/txt.png",
    className: "ht-footer__body--txt"
  })))));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(HydroTip);